import tasksRouterPaths from './tasksRouterPaths';

export default tasksRouterPaths;
